import gql from 'graphql-tag'
import { EnumFields } from '..'

export const NegotiationResponseTypeFragment = gql`
  fragment NegotiationResponseType on purchase_negotiation_response_type {
    ${EnumFields}
  }
`
